
const InternalLinkings = ({ data }) => {
  if (!data || !data.items || data.items.length === 0) return null;

  return (
    <div className="mt-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">{data.heading}</h2>
      <ul className="space-y-5">
        {data.items.map((item, index) => (
          <li key={index} className="transition">
            <a
              href={item.link}
              className="block px-4 py-2 bg-gray-50 text-gray-700 rounded-md shadow-sm hover:bg-blue-100 hover:text-blue-600"
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InternalLinkings;
